import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { addTaxResidency, confirmEmail, register, saveContactInfo } from './actions';
import { logout } from '../authorization/actions';

import { IRegistrationUser, RequestStatusTypes } from 'models';

import { apiReducerBuilder } from 'utils';
import { deleteAccountConfirm } from '../userSettings/actions';

interface Registration {
	step: number;
	entity: IRegistrationUser;
	status: RequestStatusTypes;
}

const initialState = { entity: {} } as Registration;

const registrationSlice = createSlice({
	name: 'registration',
	initialState: initialState,
	reducers: {
		leaveRegistration(state) {
			state.step = 0;
			state.entity = {} as IRegistrationUser;
		},
	},
	extraReducers: (builder) => {
		apiReducerBuilder(builder, register, (state, action) => {
			const { payload, meta }: { [key: string]: any } = action;
			state.status = meta.requestStatus;
			state.step = 1;
			state.entity = {
				...state.entity,
				...meta.arg,
				...payload,
			};
		});

		apiReducerBuilder(builder, confirmEmail, (state, action) => {
			const { meta }: { [key: string]: any } = action;
			state.status = meta.requestStatus;
			state.step = 2;
		});

		apiReducerBuilder(builder, saveContactInfo, (state, action) => {
			const { meta }: { [key: string]: any } = action;
			state.status = meta.requestStatus;
		});

		apiReducerBuilder(builder, addTaxResidency, () => {
			return initialState;
		});

		builder.addMatcher(isAnyOf(logout, deleteAccountConfirm.fulfilled), (state) => {
			state.entity = {} as IRegistrationUser;
			state.step = 0;
			state.status = 'fulfilled';
		});
	},
});

export const { leaveRegistration } = registrationSlice.actions;

export default registrationSlice.reducer;
